class V42AvailabilityManager {
    constructor() {
        this.propertyName = 'properties[Délai ]'; 
        this.dataScriptId = 'V42_Variant_Data';
        this.init();
    }

    init() {
        // Écoute les clics sur "Ajouter au panier"
        document.addEventListener('click', (e) => {
            if (e.target.matches('[name="add"], [name="add"] *')) {
                this.manageInput(e.target);
            }
        });
    }

    manageInput(target) {
        const form = target.closest('form[action*="/cart/add"]');
        if (!form) return;

        // 1. Nettoyage préventif
        const existingInput = form.querySelector(`input[name="${this.propertyName}"]`);
        if (existingInput) existingInput.remove();

        // 2. Récupération info
        const variantId = this.getCurrentVariantId(form);
        if (!variantId) return;

        const script = document.getElementById(this.dataScriptId);
        if (!script) return;

        try {
            const data = JSON.parse(script.textContent);
            const variantData = data[variantId];

            // 3. Injection UNIQUEMENT si le Liquid a renvoyé du texte
            if (variantData && variantData.dispo_calculee && variantData.dispo_calculee !== "") {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = this.propertyName;
                input.value = variantData.dispo_calculee;
                form.appendChild(input);
            }
        } catch (e) {
            console.error(e);
        }
    }

    getCurrentVariantId(form) {
        const idInput = form.querySelector('[name="id"]');
        if (idInput) return idInput.value;
        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
    }
}

new V42AvailabilityManager();